import { useNavigate } from 'react-router-dom'
import AppActionMenu from '../../../../components/AppActionMenu'
import { canAddTimesheet } from '../../../project-management/job/jobHelpers'

function overrunBadgeChip(flag) {
  if (flag === 'RED') {
    return (
      <span
        className="inline-flex items-center gap-0.5 rounded-full bg-rose-100 px-2 py-0.5 text-[9px] font-bold uppercase tracking-wider text-rose-700 shrink-0"
        title="Overrun: actual hours exceeded average by more than 20%"
      >
        <span className="material-symbols-outlined text-[10px]">warning</span>
        Overrun
      </span>
    )
  }
  if (flag === 'GREEN') {
    return (
      <span
        className="inline-flex items-center gap-0.5 rounded-full bg-emerald-100 px-2 py-0.5 text-[9px] font-bold uppercase tracking-wider text-emerald-700 shrink-0"
        title="Efficient: actual hours were below the benchmark average"
      >
        <span className="material-symbols-outlined text-[10px]">verified</span>
        Efficient
      </span>
    )
  }
  return null
}

export default function ActiveJobsCard({ jobs }) {
  const navigate = useNavigate()

  return (
    <article className="rounded-lg bg-surface-container-lowest p-6 shadow-[0_20px_40px_rgba(25,28,30,0.04)]">
      <h3 className="mb-6 flex items-center justify-between text-[11px] font-semibold uppercase tracking-wider text-on-surface-variant">
        Active Jobs
        <button
          type="button"
          className="text-[10px] text-primary hover:underline"
          onClick={() => navigate('/nerve/job/list')}
        >
          View All
        </button>
      </h3>

      <div className="space-y-6">
        {jobs.map((job) => (
          <div
            key={job.jobId || job.label}
            className="flex cursor-pointer items-center gap-4"
            onClick={() => navigate(`/nerve/job/entry?id=${job.jobId}`)}
            onKeyDown={(event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault()
                navigate(`/nerve/job/entry?id=${job.jobId}`)
              }
            }}
            role="button"
            tabIndex={0}
          >
            <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-surface-container-low text-primary-container">
              <span className="material-symbols-outlined">{job.icon}</span>
            </div>
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-1.5 min-w-0">
                <p className="text-sm font-bold text-on-surface truncate">{job.label}</p>
                {job.overrunFlag && overrunBadgeChip(job.overrunFlag)}
              </div>
              <div className="mt-1 flex items-center gap-2">
                <div className="h-1 w-24 overflow-hidden rounded-full bg-surface-variant">
                  <span className="block h-full rounded-full bg-primary" style={{ width: `${job.progress}%` }} />
                </div>
                <span className="text-[10px] font-bold text-on-surface-variant">{job.progress}%</span>
              </div>
            </div>
            <div
              onClick={(event) => event.stopPropagation()}
              onKeyDown={(event) => event.stopPropagation()}
              role="presentation"
            >
              <AppActionMenu
                triggerLabel=""
                triggerIcon="more_vert"
                showChevron={false}
                triggerClassName="h-8 w-8 rounded-md bg-transparent p-0 text-on-surface-variant hover:bg-surface-container-high hover:text-primary"
                menuClassName="min-w-[190px]"
                items={[
                  { key: 'edit_job', label: 'Edit Job', icon: 'edit' },
                  canAddTimesheet(job.status) && { key: 'add_timesheet', label: 'Add Timesheet', icon: 'event_note' },
                ].filter(Boolean)}
                onSelect={(actionKey) => {
                  if (actionKey === 'edit_job') {
                    navigate(`/nerve/job/entry?id=${job.jobId}`)
                    return
                  }
                  if (actionKey === 'add_timesheet') {
                    navigate(`/nerve/timesheet/entry?jobId=${job.jobId}`)
                  }
                }}
              />
            </div>
          </div>
        ))}
      </div>
    </article>
  )
}
